import ApiClient from './ApiClient';

class ServiceTemplatesAPI extends ApiClient {
  constructor() {
    super('service_templates', { accountScoped: true });
  }
}

export default new ServiceTemplatesAPI();
